import barba from '@barba/core';
import { gsap, ScrollTrigger, CustomEase } from "gsap/all";
gsap.registerPlugin(CustomEase);
// import Cookies from 'js-cookie';

import Header from "./header";
import NavMobile from "./nav-mobile";
import Reveal from "./reveal";

export default class BarbaJs {

  constructor() {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const headerLogo = document.querySelector('.header-logo');
    // const logoPathsArchitecture = document.querySelectorAll('.header-logo [data-name="architecture"] path');
    const navigationLinks = document.querySelectorAll('.navigation--main-link');
    const navigationTrigger = document.querySelectorAll('.header--navigation-trigger');
    let animationFrontPlayed = false;
    var scrollPosY = [0];

    barba.init({
      timeout: 7500,

      // debug: true,
      // cacheIgnore: true,
      // prefetchIgnore: true,

      // requestError: (trigger, action, url, response) => {
      //   console.log({
      //     trigger: trigger,
      //     action: action,
      //     url: url,
      //     response: response,
      //   })
      // },

      prevent: ({ el }) => el.classList && (el.classList.contains('prevent-barba') || el.classList.contains('active')),

      transitions: [
        {
          name: 'default-transition',

          once(data) {
            // scroll to anchor
            if (window.location.hash) {
              const target = document.querySelector(window.location.hash);
              if (target) {
                setTimeout(() => {
                  target.scrollIntoView({
                    behavior: 'smooth',
                  });
                }, 250);
              }
            }

            setTimeout(() => {
              new Header();
              new NavMobile();
              new Reveal('.js--reveal');
            }, 1);

            const isHome = body.classList.contains('is-home');
            const animationDelay = 1;
            if (isHome) {
              window.scrollTo(0, 0);
              // const header = document.querySelector('.header');
              var headerItems = document.querySelectorAll(window.innerWidth >= 768 ? '.header-logo, .header--navigation-wrapper' : '.header-logo');
              gsap.set(headerItems, { translateY: (window.innerHeight/2 - header.clientHeight/2) + 'px'});
            }

            return gsap.to(body, {
              opacity: 1,
              duration: 0.75,
              delay: 0.75,
              onStart: () => {
                if (isHome) {
                  if (!animationFrontPlayed) {
                    var heroOverlay = document.querySelector('.hero-overlay');
                    heroOverlay.style.opacity = 0.4;
                    var heroLinks = document.querySelector('.hero-project-link-wrapper');
                    var heroNavigation = document.querySelectorAll('.hero .swiper-button');
                    gsap.set(heroLinks, { opacity: 0 });
                    gsap.set(navigationTrigger, { opacity: 0});
                    gsap.set(heroNavigation, { opacity: 0});

                    window.scrollTo(0, 0);
                    html.style.overflowY = 'hidden';
                  }
                  gsap.to(headerItems, {
                    translateY: 0,
                    duration: 1.5,
                    delay: animationDelay,
                    ease: CustomEase.create("custom", "M0,0 C0.29,0 0.365,0.006 0.42,0.103 0.478,0.206 0.473,0.305 0.5,0.5 0.525,0.69 0.509,0.763 0.561,0.864 0.62,0.98 0.704,1 1,1"),
                    onStart: () => {
                      if (heroOverlay != undefined) {
                        heroOverlay.style.opacity = 0.4;
                        gsap.to(heroOverlay, {
                          opacity: 0,
                          duration: 1.5,
                          delay: 0.25,
                          // delay: 0.75,
                          ease: "power3.inOut"
                        });
                        gsap.to(navigationTrigger, {
                          opacity: 1,
                          duration: 1.5,
                          delay: 1,
                          ease: "power3.inOut"
                        });
                      }
                      if (heroLinks != undefined) {
                        gsap.to(heroLinks, {
                          opacity: 1,
                          duration: 1.5,
                          delay: 1,
                          ease: "power3.inOut",
                          onComplete: () => {
                            animationFrontPlayed = true;
                            html.style.overflowY = 'auto';
                          },
                        });
                      }
                      if (heroNavigation != undefined && heroNavigation.length > 0) {
                        gsap.to(heroNavigation, {
                          opacity: 1,
                          duration: 1.5,
                          delay: 1,
                          ease: "power3.inOut"
                        });
                      }
                    },
                  });
                }

                setTimeout(() => {
                  headerLogo.classList.add('hide-addition');
                }, 6000);
              }
            });
          },

          beforeLeave(data) {
            if (data.trigger !== "back") {
              scrollPosY.push(window.scrollY);
            }

            headerLogo.classList.remove('hide-addition');

            return gsap.to(data.current.container, {
              opacity: 0,
              duration: 0.5,
              delay: 0,
            });

          },

          afterLeave(data) {
            // update body classes
            body.classList.toggle('is-home', data.next.namespace === 'home');
            body.classList.toggle('not-home', data.next.namespace !== 'home');
            data.current.container.remove();
          },

          beforeEnter(data) {
            navigationLinks.forEach(navigationLink => {
              navigationLink.classList.toggle('active', navigationLink.dataset.slug === data.next.namespace || navigationLink.dataset.slug === data.next.container.dataset.slug);
            });
            data.next.container.style.opacity = 0;
          },


          enter(data) {
            // reinit JS
            setTimeout(() => {
              // new Header();
              new NavMobile();
              new Reveal('.js--reveal');
            }, 1);

            if (data.trigger == 'back') {
              window.scrollTo(0, 0);
              ScrollTrigger.refresh();
              let scrollPosYTarget = scrollPosY.pop();
              setTimeout(() => {
                window.scrollTo(0, scrollPosYTarget);
                ScrollTrigger.refresh();
              }, 10);
            } else {
              window.scrollTo(0, 0);
              ScrollTrigger.refresh();
            }
          },

          afterEnter(data) {
            return gsap.to(data.next.container, {
              opacity: 1,
              duration: 0.5,
              delay: 1,
              onComplete: () => {
                setTimeout(() => {
                  headerLogo.classList.add('hide-addition');
                }, 2000);

                // scroll to anchor
                if (window.location.hash) {
                  const target = document.querySelector(window.location.hash);
                  if (target) {
                    setTimeout(() => {
                      target.scrollIntoView({
                        behavior: 'smooth',
                      });
                    }, 250);
                  }
                }
              }
            });
          }

        },
      ],

    });
  }

}
